import { ComponentType } from '@wix/ambassador-devcenter-components-v1-component/types';

export const ALLOWED_EXTENSIONS = [
  ComponentType.CUSTOM_ELEMENT_WIDGET,
  ComponentType.STUDIO_WIDGET,
];
